module.exports = __webpack_public_path__ + "static/media/GutResetIntro.8c755613.png";